module.exports = __webpack_public_path__ + "img/code.fe9bc4b5.jpg";